export default __webpack_public_path__ + "static/media/python-programming-language-icon.af4b6d45.svg";